module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAQCAYAAADAvYV+AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAC6ADAAQAAAABAAAAEAAAAACWjvyVAAAA30lEQVQoFY2SwQ3CMAxFvyMGYIQeoXBhAmAC6AhMAFxQEBdOiJ7KCkwCI/RS4EZH4IQ4YWyhIChpwVKUxH52vq0AYm3LveaMh3quMmpZ3jAwVkj2vazRaU25L8k4UIME9Aywa1gOvLDHGUjCWWRNijHx+40MktDy8j1K4hAlFcZI74RI+/gNP+vkd6BfKqPwVkCM5F9YR1X/F851/j9hgfaqVxusFbR9XEXn5hDT1Dm9lYlwkYFOsjdQE3yVc2kmOsaUuopuN/Iftu6i+q43dLLVN+gYhAseNObcfTlKDg/wWkNQB1ZScQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newhome/hide.png
// module id = pFgK
// module chunks = 311